import cx from 'classnames'
import PropTypes from 'prop-types'

import AtomButton, {
  atomButtonColors,
  atomButtonDesigns,
  atomButtonShapes,
  atomButtonSizes
} from '@s-ui/react-atom-button'

const BASE_CLASS = 'mt-ButtonSticky'

export default function ButtonSticky({children, hide, ...props}) {
  const CLASS_STICKY_BUTTON = BASE_CLASS
  const CLASS_STICKY_BUTTON_HIDE = `${CLASS_STICKY_BUTTON}--hidden`

  const stickyClassName = cx(CLASS_STICKY_BUTTON, {
    [CLASS_STICKY_BUTTON_HIDE]: hide
  })

  return (
    <div className={stickyClassName}>
      <AtomButton
        color={atomButtonColors.PRIMARY}
        design={atomButtonDesigns.SOLID}
        shape={atomButtonShapes.CIRCULAR}
        size={atomButtonSizes.LARGE}
        {...props}
      >
        {children}
      </AtomButton>
    </div>
  )
}

ButtonSticky.displayName = 'ButtonSticky'
ButtonSticky.propTypes = {
  children: PropTypes.node,
  hide: PropTypes.bool
}
